import script from "./mv-file-record-disabled.vue?vue&type=script&setup=true&lang=js"
export * from "./mv-file-record-disabled.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__